export const LIST_PACKAGE_SERVICE_REQUEST = 'LIST_PACKAGE_SERVICE_REQUEST'
export const LIST_PACKAGE_SERVICE_SUCCESS = 'LIST_PACKAGE_SERVICE_SUCCESS'
export const LIST_PACKAGE_SERVICE_FAIL = 'LIST_PACKAGE_SERVICE_FAIL'

export const LIST_PACKAGE_SERVICE_SUMMARY_REQUEST = 'LIST_PACKAGE_SERVICE_SUMMARY_REQUEST'
export const LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS = 'LIST_PACKAGE_SERVICE_SUMMARY_SUCCESS'
export const LIST_PACKAGE_SERVICE_SUMMARY_FAIL = 'LIST_PACKAGE_SERVICE_SUMMARY_FAIL'

export const SELECT_SERVICE_PACKAGE_SERVICE_REQUEST = 'SELECT_SERVICE_PACKAGE_SERVICE_REQUEST'
export const SELECT_SERVICE_PACKAGE_SERVICE_SUCCESS = 'SELECT_SERVICE_PACKAGE_SERVICE_SUCCESS'
export const SELECT_SERVICE_PACKAGE_SERVICE_FAIL = 'SELECT_SERVICE_PACKAGE_SERVICE_FAIL'

export const SET_PRICE_PACKAGE_SERVICE_REQUEST = 'SET_PRICE_PACKAGE_SERVICE_REQUEST'
export const SET_PRICE_PACKAGE_SERVICE_SUCCESS = 'SET_PRICE_PACKAGE_SERVICE_SUCCESS'
export const SET_PRICE_PACKAGE_SERVICE_FAIL = 'SET_PRICE_PACKAGE_SERVICE_FAIL'

export const GET_PACKAGE_SERVICE_REQUEST = 'GET_PACKAGE_SERVICE_REQUEST'
export const GET_PACKAGE_SERVICE_SUCCESS = 'GET_PACKAGE_SERVICE_SUCCESS'
export const GET_PACKAGE_SERVICE_FAIL = 'GET_PACKAGE_SERVICE_FAIL'

export const GET_PACKAGE_SERVICE_REQUEST_BY_ID_REQUEST = 'GET_PACKAGE_SERVICE_REQUEST_BY_ID_REQUEST'
export const GET_PACKAGE_SERVICE_REQUEST_BY_ID_SUCCESS = 'GET_PACKAGE_SERVICE_REQUEST_BY_ID_SUCCESS'
export const GET_PACKAGE_SERVICE_REQUEST_BY_ID_FAIL = 'GET_PACKAGE_SERVICE_REQUEST_BY_ID_FAIL'

export const DELETE_PACKAGE_SERVICE_REQUEST = 'DELETE_PACKAGE_SERVICE_REQUEST'
export const DELETE_PACKAGE_SERVICE_SUCCESS = 'DELETE_PACKAGE_SERVICE_SUCCESS'
export const DELETE_PACKAGE_SERVICE_FAIL = 'DELETE_PACKAGE_SERVICE_FAIL'

export const RESET_PACKAGE_SERVICE = 'RESET_PACKAGE_SERVICE'